var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CheckBoxGroup"},[_c('el-checkbox-group',{model:{value:(_vm.checkList),callback:function ($$v) {_vm.checkList=$$v},expression:"checkList"}},_vm._l((_vm.data),function(item,index){return _c('el-checkbox',{key:index,attrs:{"label":item.url}},[_vm._t("default",null,{"item":item})],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }